import { createFileRoute } from '@tanstack/react-router';

import { Forbidden } from '@/entities/usuario';

export const Route = createFileRoute('/_private/403')({
  component: Forbidden,
});
